import axios from 'axios'

export default axios.create({
  baseURL: process.env.REACT_APP_API_SERVER_ADDRESS,
  /* withCredentials: true, */
/*   validateStatus:undefined , */
  headers: {
    "Content-type": "application/json",/* 
    'Access-Control-Allow-Origin': '*', */
    'content-type': 'multipart/form-data',
   /*  'Access-Control-Allow-Headers':'Origin, X-Requested-With, Content-Type, Accept', */
  }
});